// extracted by mini-css-extract-plugin
export default {"header":"links_header__ARrW6","boxStyle":"links_boxStyle__d9IoL","innerBoxStyle":"links_innerBoxStyle__M7t8D","buttonStyle":"links_buttonStyle__ukgqB"};